import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { propertySelector } from 'routes/DateSelection/selectors';
import { connect } from 'react-redux';
import {
  gaSetPropertyDimension,
  gaSetSourceDimension,
  gtag,
  sendPageView
} from 'utils/googleAnalytics';
import { PROPERTY_BETHLEHEM } from 'utils/constants';

const propTypes = {
  children: PropTypes.node,
  trackingId: PropTypes.string,
  history: PropTypes.shape({
    listen: PropTypes.func
  }),
  property: PropTypes.string,
  themeName: PropTypes.string,
  bethlehemFloodlightId: PropTypes.string
};

function GAListener({
  children,
  trackingId,
  history,
  property,
  themeName,
  bethlehemFloodlightId
}) {
  useEffect(() => {
    if (trackingId) {
      ReactGA.initialize(trackingId);
      gaSetPropertyDimension(property.toLowerCase());
      gaSetSourceDimension(themeName);
      sendPageView(history.location);
      return history.listen(sendPageView);
    }
  }, []);

  // Effect for initializing Floodlight tag for Bethlehem property only.
  useEffect(() => {
    if (
      bethlehemFloodlightId &&
      property.toLowerCase() === PROPERTY_BETHLEHEM
    ) {
      gtag('js', new Date());
      gtag('config', bethlehemFloodlightId);
    }
  }, [property]);

  return children;
}

GAListener.propTypes = propTypes;

export default withRouter(
  connect(
    createStructuredSelector({
      property: propertySelector
    })
  )(GAListener)
);
